import React from "react";
import { Modal as IModal, Header } from "./styles/modal";
import { ModalProps } from "antd";
import { scrim } from "src/theme/ui";

interface IModalProps extends ModalProps {
  children?: React.ReactNode;
  visibleHeader?: boolean;
  contentPadding?: string;
  Imodal?: any;
}

const Modal = ({
  visibleHeader = true,
  footer,
  title,
  width = "70%",
  children,
  onCancel,
  Imodal = IModal,
  wrapClassName,
  ...rest
}: IModalProps) => {
  return (
    <Imodal
      /* Every dialog built on this one wears the shared chrome: the 18px
         corner on a hairline, the ruled head, the sunk foot band and the
         muted close square. It is the default rather than something each of
         the twenty-odd callers has to remember, and a caller may still add
         classes of its own. */
      wrapClassName={["fina-dialog", wrapClassName].filter(Boolean).join(" ")}
      /* Plain ink that dims. The mask was a 10px blur over a FULLY
         transparent white, so the page behind was smeared but never
         darkened — every dialog in the app sat on a bed of unreadable
         content instead of on a quieted page. */
      maskStyle={{ background: scrim, backdropFilter: "none" }}
      title={title ? <Header>{title}</Header> : null}
      width={width}
      footer={footer}
      centered
      visibleHeader={visibleHeader}
      disableCancel={onCancel ? false : true}
      onCancel={onCancel}
      {...rest}
    >
      {children}
    </Imodal>
  );
};

export default Modal;
